import CityManagementPage from "./shared/CityManagementPage";
import { allCityConfigs } from "./shared/cityConfigExtended";

export default function Bristol() {
  return <CityManagementPage config={allCityConfigs.bristol} />;
}